import React, { useRef } from "react";
export var useKeyboardNavigation = function (children) {
    var focusedNodeId = useRef("");
    var accordionItemIds = React.Children.map(children, function (child) { return child.props.id; });
    var onKeyDown = function (event) {
        switch (event.key) {
            case "ArrowUp": {
                var itemIndex = findItemIndex(accordionItemIds, focusedNodeId);
                focusedNodeId.current = !!accordionItemIds[itemIndex - 1]
                    ? accordionItemIds[itemIndex - 1]
                    : accordionItemIds[accordionItemIds.length - 1];
                focusElement(focusedNodeId);
                break;
            }
            case "ArrowDown": {
                var itemIndex = findItemIndex(accordionItemIds, focusedNodeId);
                focusedNodeId.current = !!accordionItemIds[itemIndex + 1]
                    ? accordionItemIds[itemIndex + 1]
                    : accordionItemIds[0];
                focusElement(focusedNodeId);
                break;
            }
        }
    };
    return { focusedNodeId: focusedNodeId, onKeyDown: onKeyDown };
};
function findItemIndex(items, focusedNodeId) {
    return items.findIndex(function (id) { return id === focusedNodeId.current; }) === -1
        ? 0
        : items.findIndex(function (id) { return id === focusedNodeId.current; });
}
function focusElement(focusedNodeId) {
    var _a;
    (_a = document.querySelector("#" + focusedNodeId.current + " button")) === null || _a === void 0 ? void 0 : _a.focus();
}
